import { AdminPageListPanelProps } from './admin-page-list-panel-props';
import loadable from '@loadable/component';

export const AsyncAdminPageListPanel = loadable<AdminPageListPanelProps>(
  (): Promise<any> => import('./admin-page-list-panel'),
);
